import React,{useCallback}from'react';import PropTypes from'prop-types';import {ContactUs as ContactUs$1}from'@manulife/mux';import {useIntl}from'react-intl';import usePathBuilder from'../../../hooks/usePathBuilder.js';import useCoBranding from'../../../hooks/useCoBranding.js';import FormattedRichMessage from'../../FormattedRichMessage/FormattedRichMessage.js';function ContactUs(props) {
  var absoluteCiamDomain = props.absoluteCiamDomain;
  var pathBuilder = usePathBuilder();
  var coBranding = useCoBranding();
  var intl = useIntl();
  var handleClick = useCallback(function () {
    var _coBranding$brand;
    var url = (coBranding === null || coBranding === void 0 ? void 0 : (_coBranding$brand = coBranding.brand) === null || _coBranding$brand === void 0 ? void 0 : _coBranding$brand.contactUrl) || "".concat(absoluteCiamDomain).concat(pathBuilder('/contact'));
    window.open(url, '_blank', 'noopener noreferrer');
  }, [pathBuilder, absoluteCiamDomain, coBranding]);
  return /*#__PURE__*/React.createElement(ContactUs$1, {
    label: /*#__PURE__*/React.createElement(FormattedRichMessage, {
      id: "shared.layout.utilityBar.contactUs"
    }),
    "aria-label": intl.formatMessage({
      id: 'shared.layout.utilityBar.contactUs.ariaLabel'
    }),
    onClick: handleClick
  });
}
process.env.NODE_ENV !== "production" ? ContactUs.propTypes = {
  absoluteCiamDomain: PropTypes.string
} : void 0;
ContactUs.defaultProps = {
  absoluteCiamDomain: ''
};export{ContactUs as default};